import styled from "styled-components";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/functions";
import "firebase/messaging";

import loGet from "lodash.get";

export { firebase, loGet, styled };



// WEBPACK FOOTER //
// ./src/utils/alias.js